import "./Technology.module.css";
import NavegaciNPrincipal from "@/reusable_sections/Header";
import InteligenciaEnSeguridad from "./sections/InteligenciaEnSeguridad";
import Monitoreo247 from "./sections/Monitoreo247";
import SolicitarDiagnSticoTecnolGico from "./sections/SolicitarDiagnSticoTecnolGico";
import InformaciNCorporativa from "@/reusable_sections/Footer";
export default function TechnologyPage() {
  return <div>
      <NavegaciNPrincipal />
      <InteligenciaEnSeguridad />
      <Monitoreo247 />
      <SolicitarDiagnSticoTecnolGico />
      <InformaciNCorporativa />
    </div>;
}